import { useSuspenseQuery } from "@tanstack/react-query";
import { customerStateWidgetQueryOptions } from "../service/dashboard";
import { Suspense } from "react";
import RootUserLayout from "../layout";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import SalesflareBoard, { Opportunity } from "./salesflare-board";

export default function Leads() {
  return (
    <RootUserLayout
      pageTitle="Leads Dashboard"
      pageDescription="Leads Management (Salesflare)"
    >
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Customers..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <LeadsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}

function LeadsContent() {
  const { data } = useSuspenseQuery(customerStateWidgetQueryOptions);
  return <SalesflareBoard opportunities={data as Opportunity[]} />;
}
